import { CanAccess, useTranslate } from "ra-core";

import { SettingsGroup, SettingsRow } from "../settings/MobileSettingsList";
import { MOBILE_ADMIN_ENTRIES, type MobileModuleEntry } from "./mobileModules";

const ModuleRow = ({ entry }: { entry: MobileModuleEntry }) => {
  const translate = useTranslate();
  const { icon: Icon } = entry;
  const row = (
    <SettingsRow
      to={entry.to}
      icon={<Icon className="size-[1.0625rem]" strokeWidth={2.1} />}
      label={translate(entry.label, { smart_count: 2 })}
      chevron
    />
  );
  return entry.access ? (
    <CanAccess resource={entry.access.resource} action={entry.access.action}>
      {row}
    </CanAccess>
  ) : (
    row
  );
};

/**
 * The desktop user menu's administration entries: users and CRM settings
 * only for admins, import for everyone, as on desktop.
 */
export const MobileAdminGroup = () => {
  const translate = useTranslate();

  return (
    <SettingsGroup title={translate("crm.mobile.admin_group")}>
      {MOBILE_ADMIN_ENTRIES.map((entry) => (
        <ModuleRow key={entry.to} entry={entry} />
      ))}
    </SettingsGroup>
  );
};
